<div class="results-container" *ngIf="data$ | async as data" [ngClass] ="viewSwitch ? 'result-continer-mobile': 'result-continer-mobile-off'">
  <div *ngIf="isDataLoaded; else errorPage"></div>
  <VFA-detail-view *ngIf="viewSwitch" [closeFilters]='closeFilters' [openFilter]='openFilter' [fullData]="data.fund?.entity | sortBy: sortColumn: sortDirection: switchModel" [comparedFunds]='comparedFunds' [pageNumber]='page' [disableSwitch]='disableSwitch' (changeResultsData)="changeSortData($event)" [sortDirection]='sortDirection' [sortColumn]='sortColumn' [filterBy]='filterBy'></VFA-detail-view>
  <div class="paginationView">
    <list-pagination *ngIf="data.fund?.entity?.length > 0" [listSize]="data.fund?.entity?.length" (pageNumber)="setPage($event)"></list-pagination>
  </div>
  
  <ng-template #errorPage>
    <div class="results-container">
      <p class="error-page">An error occured on page load</p>
    </div>    
  </ng-template>
</div>


